import { Button } from "@/components/ui/button";

interface ProfileFormActionsProps {
  isEditing: boolean;
  isPending: boolean;
  onEdit: () => void;
  onCancel: () => void;
  onUpdatePassword: () => void;
}

const ProfileFormActions = ({ isEditing, isPending, onEdit, onCancel, onUpdatePassword }: ProfileFormActionsProps) => {
  return (
    <div className="flex justify-center gap-4">
      {/* show buttons when editing profile */}
      {isEditing && (
        <>
          <Button
            type="button"
            variant="ghost"
            onClick={onCancel}
            className="text-sm"
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="ghost"
            disabled={isPending}
            className="text-sm"
          >
            {isPending ? "Saving..." : "Save"}
          </Button>
        </>
      )}
      {/* show buttons */}
      {!isEditing && (
        <div className="inline-flex items-end justify-center gap-4">
          <button
            type="button"
            onClick={onEdit}
            className="text-sm text-muted-foreground hover:text-foreground mt-2"
          >
            Update profile
          </button>
          <div className="w-0 border-l-2 border-border h-2/3" />
          <button
            type="button"
            onClick={onUpdatePassword}
            className="text-sm text-muted-foreground hover:text-foreground mt-2"
          >
            Update password
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileFormActions;